var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPremiumStory = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 26,
  fill: "none",
  viewBox: "0 0 18 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M4 13h10v12l-5-2.823L4 25z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 8,
  fill: "#000",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 1.2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.728 4.586a.3.3 0 0 1 .544 0l1.074 2.313a.3.3 0 0 0 .236.171l2.532.307a.3.3 0 0 1 .168.518L11.414 9.63a.3.3 0 0 0-.09.278l.49 2.502a.3.3 0 0 1-.44.32l-2.228-1.24a.3.3 0 0 0-.292 0l-2.228 1.24a.3.3 0 0 1-.44-.32l.49-2.502a.3.3 0 0 0-.09-.278L4.718 7.895a.3.3 0 0 1 .168-.518l2.532-.307a.3.3 0 0 0 .236-.171z"
})));
export default SvgPremiumStory;